module.exports = __webpack_public_path__ + "img/Group 139.8b551329.png";